import { ChangeEvent, ReactNode } from 'react';
import styles from './settings-form.module.css';

export default function SettingsSelectField({
  label,
  value,
  onChange,
  children,
  helpText,
  disabled,
}: {
  label: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
  children: ReactNode;
  helpText?: ReactNode;
  disabled?: boolean;
}) {
  return (
    <div className={styles.fieldRow}>
      <label className={styles.fieldLabel}>{label}</label>
      <select value={value} className="form-control" onChange={onChange} disabled={disabled}>
        {children}
      </select>
      {helpText && <div className={styles.helpText}>{helpText}</div>}
    </div>
  );
}
